const STRIPE_SCRIPT_URL = 'https://js.stripe.com/v3/'

// on a bad network the script request can hang without ever firing onerror,
// so we need our own deadline to be able to report the failure to the customer
const LOAD_TIMEOUT_MS = 10000

let loadPromise = null

// Loads Stripe.js once per page and hands the same promise to every caller.
// Rejects on a network error or when the load takes longer than LOAD_TIMEOUT_MS,
// so the payment forms can disable themselves instead of failing silently.
export default function loadStripeScript() {
  if (loadPromise) return loadPromise

  loadPromise = new Promise((resolve, reject) => {
    // the script may already be on the page (some views include it directly)
    // or may have arrived after a previous attempt timed out
    if (window.Stripe) {
      resolve()
      return
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = STRIPE_SCRIPT_URL

    const timer = setTimeout(() => reject(new Error('Stripe.js load timed out')), LOAD_TIMEOUT_MS)

    script.onload = () => {
      clearTimeout(timer)
      // a loaded script without the global means we got something that isn't Stripe.js
      window.Stripe ? resolve() : reject(new Error('Stripe.js loaded without the Stripe global'))
    }
    script.onerror = () => {
      clearTimeout(timer)
      reject(new Error('Stripe.js failed to load'))
    }

    document.getElementsByTagName('head')[0].appendChild(script)
  })

  // allow a later attempt to retry after a network blip,
  // the window.Stripe check above keeps us from injecting a second working script
  loadPromise.catch(() => { loadPromise = null })

  return loadPromise
}
